import { uiText } from '../../i18n';

/** The protected preview is the only audio the clone API currently publishes.
 * Do not invent translated examples, language counts, text or duration.
 * Подписи блока идут через словарь профиля; фраза примера — то, что звучит в превью, она не переводится. */
export function serverPreviewHTML(
  voice: { id: number; hasPreview: boolean },
  view: { playing: boolean; play: string; pause: string; wave: string },
): string {
  const ut = (s: string) => uiText(s);
  if (!voice.hasPreview)
    return `<div class="gr vsm"><div class="top"><span>${ut('Пример звучания')}</span></div><p class="hintp">${ut('Пример звучания пока недоступен')}</p></div>`;
  return `<div class="gr vsm"><div class="top"><span>${ut('Пример звучания')}</span><span>${ut('Превью голоса')}</span></div>
    <div class="exb"><div class="exp"><p class="phq">Проверка моего голоса.</p>
      <div class="ln"><button class="pb" type="button" data-vplay="${voice.id}" aria-label="${view.playing ? ut('Пауза') : ut('Прослушать пример')}"><span>${view.playing ? view.pause : view.play}</span></button>
      <div class="wv" aria-hidden="true">${view.wave}</div><span class="tm">—</span></div>
    </div></div></div>`;
}
